<template>
	<hr class="dot-menu-separator">
</template>

<script>
export default {
	name: 'DotMenuSeparator',
	props: [],
	data() {
		return {
		}
	},
	methods: {
	}
}
</script>

<style scoped>
.dot-menu-separator {
	height: 0;
	border: none;
	margin: 0;
	border-bottom: .1rem solid rgba(0, 0, 0, 0.12);
}
</style>